import { Grid, Typography, Paper, Button, Tooltip } from "@mui/material";

const NoDataLayout = ({
  title,
  description,
  buttonText,
  onButtonClick,
  imagePath,
  imageAlt = "Feature illustration",
  disabled,
  action
}) => (
  <Grid container spacing={2} alignItems="stretch">
    <Grid
      item
      xs={6}
      container
      direction="column"
      spacing={4}
      justifyContent="center"
    >
      <Grid item>
        <Typography variant="h2" paragraph>
          {title}
        </Typography>
        <Typography variant="h5">{description}</Typography>
      </Grid>
      <Grid item container justifyContent="center">
        <Grid item>
          {action || (
            <Tooltip
              title="This feature is not available in Simulation Mode"
              disableHoverListener={!disabled}
            >
              <span>
                <Button
                  size="large"
                  variant="contained"
                  color="secondary"
                  onClick={onButtonClick}
                  disabled={disabled}
                >
                  {buttonText}
                </Button>
              </span>
            </Tooltip>
          )}
        </Grid>
      </Grid>
    </Grid>
    <Grid item xs={6} container justifyContent="center" alignItems="center">
      <Paper
        style={{
          height: "100%",
          minHeight: 600,
          width: "100%",
          backgroundImage: imagePath ? `url('${imagePath}')` : undefined,
          backgroundColor: imagePath ? undefined : "#f5f5f5",
          backgroundSize: "cover",
          backgroundPosition: "center center",
          display: imagePath ? undefined : "flex",
          alignItems: imagePath ? undefined : "center",
          justifyContent: imagePath ? undefined : "center"
        }}
      >
        {!imagePath && (
          <Typography variant="h4" color="textSecondary">
            {imageAlt}
          </Typography>
        )}
      </Paper>
    </Grid>
  </Grid>
);

export default NoDataLayout;
